// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step-indicator .step-indicator-content{column-gap:0.5rem}@media screen and (min-width: 1700px){.step-indicator .step-indicator-content .label{display:flex;flex-direction:column;align-items:center;padding-top:4px}.step-indicator .step-indicator-content .label span{line-height:1.3}}\n", ""]);
// Exports
module.exports = exports;
